import { Facebook, Instagram, Linkedin, Mail, Phone, MessageCircle } from "lucide-react";

const LOGO = "https://customer-assets.emergentagent.com/job_rp-profesional/artifacts/bgdftrab_logoblanco.png";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="relative text-slate-300 pt-16 pb-8"
      style={{ background: "var(--rp-ink)" }}
    >
      <div
        className="absolute top-0 inset-x-0 h-1"
        style={{ background: "linear-gradient(90deg, var(--rp-blue), var(--rp-green), var(--rp-teal))" }}
      />
      <div className="rp-container">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <div className="flex items-center gap-3">
              <img src={LOGO} alt="Contadores RP" className="h-20 w-20 object-contain" />
              <div className="text-[10px] uppercase tracking-[0.18em] text-slate-400">Firma multidisciplinaria · 2008</div>
            </div>
            <p className="mt-5 text-sm text-slate-400 leading-relaxed">
              Decisiones fiscales y patrimoniales que resisten el tiempo y la autoridad.
            </p>
          </div>

          <div>
            <h4 className="text-sm font-bold text-white uppercase tracking-wider mb-4">Navega</h4>
            <ul className="space-y-2 text-sm">
              <li><a href="#nosotros" className="hover:text-white transition">Nosotros</a></li>
              <li><a href="#servicios" className="hover:text-white transition">Servicios</a></li>
              <li><a href="#plataforma" className="hover:text-white transition">Plataforma RP</a></li>
              <li><a href="#beneficios" className="hover:text-white transition">Por qué elegirnos</a></li>
              <li><a href="#contacto" className="hover:text-white transition">Contacto</a></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-bold text-white uppercase tracking-wider mb-4">Contacto</h4>
            <ul className="space-y-3 text-sm">
              <li className="flex items-center gap-2"><Phone className="w-4 h-4 text-[color:var(--rp-teal)]" /> (33) 1592 9485</li>
              <li className="flex items-center gap-2"><MessageCircle className="w-4 h-4 text-[color:var(--rp-teal)]" /> +52 1 33 1090 2798</li>
              <li className="flex items-center gap-2"><Mail className="w-4 h-4 text-[color:var(--rp-teal)]" /> contacto@contadoresrp.com</li>
              <li className="text-slate-400 text-xs leading-relaxed pt-1">
                Av. de la Libertad 1041, Prados Tepeyac, 45047 Zapopan, Jalisco
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-bold text-white uppercase tracking-wider mb-4">Síguenos</h4>
            <div className="flex gap-3">
              <a
                href="https://www.facebook.com/contadoresrp/"
                target="_blank"
                rel="noreferrer"
                data-testid="footer-facebook"
                className="w-10 h-10 rounded-full bg-white/5 hover:bg-[color:var(--rp-blue)] flex items-center justify-center transition-colors"
                aria-label="Facebook"
              >
                <Facebook className="w-4 h-4" />
              </a>
              <a
                href="https://www.instagram.com/contadoresrp_/"
                target="_blank"
                rel="noreferrer"
                data-testid="footer-instagram"
                className="w-10 h-10 rounded-full bg-white/5 hover:bg-[color:var(--rp-green)] flex items-center justify-center transition-colors"
                aria-label="Instagram"
              >
                <Instagram className="w-4 h-4" />
              </a>
              <a
                href="https://www.linkedin.com/in/juan-pablo-rodriguez-garcia-bb3a52370?utm_source=share_via&utm_content=profile&utm_medium=member_ios"
                target="_blank"
                rel="noreferrer"
                data-testid="footer-linkedin"
                className="w-10 h-10 rounded-full bg-white/5 hover:bg-[color:var(--rp-teal)] flex items-center justify-center transition-colors"
                aria-label="LinkedIn — Director General"
                title="LinkedIn — Juan Pablo Rodríguez"
              >
                <Linkedin className="w-4 h-4" />
              </a>
            </div>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-white/10 flex flex-col sm:flex-row gap-3 justify-between items-center text-xs text-slate-400">
          <div>© {new Date().getFullYear()} Contadores RP. Todos los derechos reservados.</div>
          <div>Guadalajara y Ciudad de México (Torre Mayor).</div>
        </div>
      </div>
    </footer>
  );
}
